<template>
  <div class="action-buttons">
    <button 
      class="action-btn" 
      :class="{ loading: isBackgroundLoading }"
      @click="$emit('refreshBackground')" 
      :title="t('ui.changeBackground')"
    >
      <div v-if="isBackgroundLoading" class="loading-spinner"></div>
      <svg v-else viewBox="0 0 24 24" fill="none">
        <rect x="3" y="3" width="18" height="18" rx="2" ry="2"/>
        <circle cx="8.5" cy="8.5" r="1.5"/>
        <polyline points="21,15 16,10 5,21"/>
      </svg>
      <span class="tooltip">{{ t('ui.changeBackground') }}</span>
    </button>
    
    
    <button 
      class="action-btn" 
      :class="{ loading: isQuoteLoading }"
      @click="$emit('refreshQuote')" 
      :title="t('ui.changeQuote')"
    >
      <div v-if="isQuoteLoading" class="loading-spinner"></div>
      <svg v-else viewBox="0 0 24 24" fill="none">
        <path d="M1 4v6h6M23 20v-6h-6"/>
        <path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/>
      </svg>
      <span class="tooltip">{{ t('ui.changeQuote') }}</span>
    </button>
  </div>
</template>

<script>
import { useI18n } from '@/i18n'

export default {
  name: 'ActionButtons',
  props: {
    isBackgroundLoading: {
      type: Boolean,
      default: false
    },
    isQuoteLoading: {
      type: Boolean,
      default: false
    },
  },
  emits: ['refreshBackground', 'refreshQuote'],
  setup() {
    const { t } = useI18n()
    
    return {
      t
    }
  }
}
</script>

<style scoped>
.action-buttons {
  position: fixed;
  bottom: 160px;
  right: 20px;
  display: flex;
  flex-direction: column;
  gap: 15px;
  z-index: 200;
}

.action-btn {
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 50%;
  width: 50px;
  height: 50px;
  color: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.action-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  border-color: rgba(255, 255, 255, 0.4);
  color: white;
  transform: scale(1.05);
}

.action-btn.loading {
  pointer-events: none;
  opacity: 0.6;
}

.action-btn svg {
  width: 24px;
  height: 24px;
  stroke: currentColor;
  stroke-width: 2;
}

.action-btn .tooltip {
  position: absolute;
  right: 70px;
  top: 50%;
  transform: translateY(-50%);
  background: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 0.85rem;
  white-space: nowrap;
  opacity: 0;
  pointer-events: none;
  transition: opacity 0.3s;
}

.action-btn:hover .tooltip {
  opacity: 1;
}

.loading-spinner {
  display: inline-block;
  width: 20px;
  height: 20px;
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 50%;
  border-top-color: white;
  animation: spin 1s ease-in-out infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* 移动端响应式 */
@media (max-width: 768px) {
  .action-buttons {
    bottom: 95px;
    right: 70px;
    flex-direction: row;
    gap: 10px;
  }

  .action-btn {
    width: 45px;
    height: 45px;
  }

  .action-btn svg {
    width: 22px;
    height: 22px;
  }

  .action-btn .tooltip {
    display: none;
  }
}

@media (max-width: 480px) {
  .action-buttons {
    bottom: 95px;
    right: 62px;
    gap: 10px;
  }

  .action-btn {
    width: 40px;
    height: 40px;
  }

  .action-btn svg {
    width: 20px;
    height: 20px;
  }
}

@media (max-height: 500px) and (orientation: landscape) {
  .action-buttons {
    bottom: 60px;
    right: 10px;
  }

  .action-btn {
    width: 35px;
    height: 35px;
  }
}
</style>